import React from "react";
import { createBrowserRouter } from "react-router-dom";

import { Layout } from "../Layout";

import { RegistrationContainer } from "../containers/RegistrationContainer";

import { RegistrationBusinessForm } from "../modules/registration/RegistrationBusinessForm";
import { VerifyProfileForm } from "../modules/registration/VerifyProfileForm";
import { LoginForm } from "../modules/login/LoginForm";
import { SmsLoginForm } from "../modules/smslogin/SmsLoginForm";
import { SmsLoginLink } from "../modules/smslogin/SmsLoginLink";
import { TwoFactorForm } from "../modules/twofactor/TwoFactorForm";
import { ResetPasswordForm } from "../modules/password/ResetPasswordForm";
import { PasswordlessLinkForm } from "../modules/password/PasswordlessLinkForm";
import { ForgotPasswordForm } from "../modules/password/ForgotPasswordForm";
import { LogoutForm } from "../modules/logout/LogoutForm";
import { VippsConnectForm } from "../modules/vipps/VippsConnectForm";

export const router = createBrowserRouter([
	{
		path: "/",
		element: <Layout layoutversion="logout" />,
		children: [
			{
				path: "logout",
				element: <LogoutForm />,
			},
			{
				path: "requestlogout",
				element: <LogoutForm />,
			},
		],
	},
	{
		path: "/login",
		element: <Layout layoutversion="login" />,
		children: [
			{
				path: "/login/local",
				element: <LoginForm />,
			},
		],
	},
	{
		path: "/password",
		element: <Layout layoutversion="password" />,
		children: [
			{
				path: "/password/reset/:nonce",
				element: <ResetPasswordForm />,
			},
			{
				path: "/password/forgot",
				element: <ForgotPasswordForm />,
			},
			{
				path: "/password/loginlink",
				element: <PasswordlessLinkForm />,
			},
		],
	},
	{
		path: "/register",
		element: <Layout layoutversion="register" />,
		children: [
			{
				path: "/register/private",
				element: <RegistrationContainer />,
			},
			{
				path: "/register/business",
				element: <RegistrationBusinessForm />,
			},
			{
				path: "/register/business/profile/complete",
				element: <VerifyProfileForm />,
			},
		],
	},
	{
		path: "/smslogin",
		element: <Layout layoutversion="smslogin" />,
		children: [
			{
				path: "/smslogin",
				element: <SmsLoginForm />,
			},
			{
				path: "/smslogin/link",
				element: <SmsLoginLink />,
			},
		],
	},
	{
		path: "/twofactor",
		element: <Layout layoutversion="twofactor" />,
		children: [
			{
				path: "/twofactor",
				element: <TwoFactorForm />,
			},
		],
	},
	{
		path: "/vipps",
		element: <Layout layoutversion="vipps" />,
		children: [
			{
				path: "/vipps/connect/:vippsId",
				element: <VippsConnectForm />,
			},
		],
	},
]);
